import React from 'react'

import { IIntakeStep } from './IIntakeStep'
import { IntakeStepButton } from './IntakeStepButton'
import { ANSWER_INDEX, ReviewStepRadioButtons } from './ReviewStepRadioButtons'

/* tslint:disable */
export const review2Steps: IIntakeStep[] = [
  {
    Component: IntakeStepButton, buttonLabel: 'Start', children: <div>
    In order to ensure that the WebTIPS site is effective in teaching you everything you need to know about preparing for your child's surgery, we'd like to ask you a few questions about the section you just read. Just click the answer you think is correct!
      <br /><br />
    Once you've answered the questions, you'll be able to move on to the next section.
    </div>, completed: intake => !!intake.review2CheckedDescribeText,
    label: 'Surgery Review',
    name: 'review2CheckedDescribeText',
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review2GuidelinesEatingAndDrinkingBeforeSurgery,
    label: 'What are the common guidelines for eating and drinking before surgery?',
    name: 'review2GuidelinesEatingAndDrinkingBeforeSurgery',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was B.',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    options: [{
      correct: false,
      label: 'A: No solid foods for 24 hours before surgery - only clear liquids',
      value: 'noSolids24h',
    },
    {
      correct: true,
      label: 'B: No solid foods after midnight and clear liquids up to 2-3 hours before surgery',
      value: 'noSolids2h',
    },
    {
      correct: false,
      label: 'C: Solid foods up to an hour before surgery and clear liquids in the hour before surgery',
      value: 'noSolids1h',
    },
    {
      correct: false,
      label: 'D: No food or liquids for 24 hours before surgery',
      value: 'noSolidsNoLiquids',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review2KeepChildCalm,
    label: 'One of the best ways to keep your child calm in the waiting area before surgery is: ',
    name: 'review2KeepChildCalm',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    options: [{
      correct: true,
      label: 'A: Distract your child with activities and conversation',
      value: 'distract',
    },
    {
      correct: false,
      label: 'B: Keep your child focused on the pain they will have after surgery',
      value: 'focusPain',
    },
    {
      correct: false,
      label: 'C: Have a snack with your child',
      value: 'snack',
    },
    {
      correct: false,
      label: 'D: Read a book by yourself and leave your child alone',
      value: 'leaveAlone',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review2TrueAboutParentsExcept,
    label: 'All of the following is true about parents in the operating room except:',
    name: 'review2TrueAboutParentsExcept',
    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was D. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.D,
    ],
    options: [{
      correct: false,
      label: 'A: Plan ahead some distractions that you can use in the operating room with your child',
      value: 'PlanDistractions',
    },
    {
      correct: false,
      label: 'B: You will be in the operating room only when your child goes to sleep',
      value: 'OnlyWhenGoesSleep',
    },
    {
      correct: false,
      label: 'C: Be sure to make constant eye contact with your child and hold your child’s hand when you are in the ' +
        'operating room',
      value: 'EyeContactHoldHand',
    },
    {
      correct: true,
      label: 'D: You will be in the operating room throughout the entire surgical procedure',
      value: 'ThroughoutOperation',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review2TrueAboutSedativeMedExcept,
    label: 'All of the following is true about sedative medication except:',
    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was C. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.C,
    ],
    name: 'review2TrueAboutSedativeMedExcept', options: [{
      correct: false,
      label: 'A: It will be given to your child in the form of a syrup',
      value: 'syrup',
    },
    {
      correct: false,
      label: 'B: It may make your child act a little silly',
      value: 'silly',
    },
    {
      correct: true,
      label: 'C: It will be injected into your child\'s buttock',
      value: 'injected',
    },
    {
      correct: false,
      label: 'D: It will make your child not remember being taken into the operating room',
      value: 'notRemember',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review2ImportantOneParentInLobby,
    label: 'It will be important for one parent to remain in the lobby while your child is in surgery.',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
      ANSWER_INDEX.D,
    ],
    name: 'review2ImportantOneParentInLobby', options: [{
      correct: true,
      label: 'A: True',
      value: 'true',
    },
    {
      correct: false,
      label: 'B: False',
      value: 'false',
    }],
  },
]





// WEBPACK FOOTER //
// ./src/organisms/Intakes/review2Steps.tsx